export default __webpack_public_path__ + "fonts/poppins-latin-900-normal.e9a4612ce05576898118.woff";